import * as $ from "jquery";
import {$body} from 'Core/Body';
import ServiceREST from "Core/ServiceREST";
import {Notifications} from 'Core/Notifications';
import {ReCaptcha} from 'Core/ReCaptcha';
import Spinner from "Core/Spinner";
import PasswordFields from "./Fields/PasswordFields";

export default class Register extends ServiceREST {

    readonly Selector: any;
    spinner: typeof Spinner;

    constructor(spinner: typeof Spinner) {
        super();
        super.rest = this.rest.bind(this);
        this.validate = this.validate.bind(this);
        // this.prepare = this.prepare.bind(this);
        this.validation = this.validation.bind(this);
        this.Selector = {
            FORM: '#registerForm'
        }
        this.spinner = spinner;
    }

    // public async prepare() {
    //
    //     let url = $(this.Selector.FORM).attr("data-api-url");
    //
    //     let data = {
    //         user_email: $("#user_email").val(),
    //         user_first_name: $("#first_name").val(),
    //         user_last_name: $("#last_name").val(),
    //         user_password: $("#userPassword").val(),
    //         user_agree_rules: $("#user_agree_rules:checked").val(),
    //         user_agree_marketing: $("#user_agree_marketing:checked").val(),
    //         recaptcha: $(`${this.Selector.FORM} #g-recaptcha [name=g-recaptcha-response]`).val()
    //     };
    //
    //     let response = await this.validation(url, data);
    //
    //     if (response) {
    //         this.spinner.spinner();
    //
    //         let user = await super.rest('post', url, data);
    //
    //         const serviceTPL = new ServiceTPL();
    //
    //         let template = await serviceTPL.tpl(user['message_tpl_link']);
    //
    //         $('#api-input').html(template);
    //
    //     }
    // }

    public validate() {
        let rules = PasswordFields.getFields(this.Selector);

        Object.assign(rules, {
            user_email: {
                required: true,
                remote: {
                    url: "/pl/api/v1/register/check_email",
                    type: "post",
                    data: {}
                }
            },
            first_name: "required",
            last_name: "required",
            agree_rules: "required",
            agree_account: "required"
        })

        $(this.Selector.FORM).validate({
            rules: rules
        });
    }

    private async validation(url, data) {
        let rules = {
            user_email: {
                required: true,
                remote: {
                    url: "/pl/api/v1/register/check_email",
                    type: "post",
                    data: {}
                }
            },
            first_name: "required",
            last_name: "required",
            agree_rules: "required",
            agree_account: "required"
        };

        Object.assign({rules},
            PasswordFields.getFields(this.Selector)
        );

        $(this.Selector.FORM).on('submit', (e) => {
            e.preventDefault();
        }).validate({
            rules: rules,
            onclick: (element) => {
                $(element).valid();
            }
        });

        let response = $(this.Selector.FORM).valid();

        if (response) {

            if (data['recaptcha'] == '') {
                response = false;
                Notifications.add('Pole reCaptcha jest nieprawidłowe', 'error');
            }

            let checkUserByEmail = await super.rest('get', url + '/check_user_existence_by_email/' + data['user_email']);


            if (checkUserByEmail) {
                response = !checkUserByEmail;
                Notifications.add('Użytkownik z takim adresem email juz istnieje', 'error');
            }
        }

        return response;
    }

    // public submit() {
    //     $body.on('click', '#sendRegistrationForm', this.prepare);
    // }

    public createRecaptcha() {
        let recaptcha = new ReCaptcha();

        let sitekey = $('#g-recaptcha').attr('data-sitekey');


        setTimeout(function () {
            $body.ready(() => {
                recaptcha.render(sitekey, 'g-recaptcha')
            })
        }, 500);
    }

    public onLoad() {
        $(this.Selector.FORM).on("load", this.validate);
    }

    public onChange() {
        $(this.Selector.FORM).on("change", this.validate);
    }
}

const register = new Register(Spinner);
register.createRecaptcha();
// register.submit();
register.onLoad();
register.onChange();
import * as $ from "jquery";
import {$body} from 'Core/Body';
import ServiceREST from "Core/ServiceREST";
import {Notifications} from 'Core/Notifications';
import {ReCaptcha} from 'Core/ReCaptcha';
import Spinner from "Core/Spinner";
import PasswordFields from "./Fields/PasswordFields";

export default class Register extends ServiceREST {

    readonly Selector: any;
    spinner: typeof Spinner;

    constructor(spinner: typeof Spinner) {
        super();
        super.rest = this.rest.bind(this);
        this.validate = this.validate.bind(this);
        // this.prepare = this.prepare.bind(this);
        this.validation = this.validation.bind(this);
        this.Selector = {
            FORM: '#registerForm'
        }
        this.spinner = spinner;
    }

    // public async prepare() {
    //
    //     let url = $(this.Selector.FORM).attr("data-api-url");
    //
    //     let data = {
    //         user_email: $("#user_email").val(),
    //         user_first_name: $("#first_name").val(),
    //         user_last_name: $("#last_name").val(),
    //         user_password: $("#userPassword").val(),
    //         user_agree_rules: $("#user_agree_rules:checked").val(),
    //         user_agree_marketing: $("#user_agree_marketing:checked").val(),
    //         recaptcha: $(`${this.Selector.FORM} #g-recaptcha [name=g-recaptcha-response]`).val()
    //     };
    //
    //     let response = await this.validation(url, data);
    //
    //     if (response) {
    //         this.spinner.spinner();
    //
    //         let user = await super.rest('post', url, data);
    //
    //         const serviceTPL = new ServiceTPL();
    //
    //         let template = await serviceTPL.tpl(user['message_tpl_link']);
    //
    //         $('#api-input').html(template);
    //
    //     }
    // }

    public validate() {
        let rules = PasswordFields.getFields(this.Selector);

        Object.assign(rules, {
            user_email: {
                required: true,
                remote: {
                    url: "/pl/api/v1/register/check_email",
                    type: "post",
                    data: {}
                }
            },
            first_name: "required",
            last_name: "required",
            agree_rules: "required",
            agree_account: "required"
        })

        $(this.Selector.FORM).validate({
            rules: rules
        });
    }

    private async validation(url, data) {
        let rules = {
            user_email: {
                required: true,
                remote: {
                    url: "/pl/api/v1/register/check_email",
                    type: "post",
                    data: {}
                }
            },
            first_name: "required",
            last_name: "required",
            agree_rules: "required",
            agree_account: "required"
        };

        Object.assign({rules},
            PasswordFields.getFields(this.Selector)
        );

        $(this.Selector.FORM).on('submit', (e) => {
            e.preventDefault();
        }).validate({
            rules: rules,
            onclick: (element) => {
                $(element).valid();
            }
        });

        let response = $(this.Selector.FORM).valid();

        if (response) {

            if (data['recaptcha'] == '') {
                response = false;
                Notifications.add('Pole reCaptcha jest nieprawidłowe', 'error');
            }

            let checkUserByEmail = await super.rest('get', url + '/check_user_existence_by_email/' + data['user_email']);


            if (checkUserByEmail) {
                response = !checkUserByEmail;
                Notifications.add('Użytkownik z takim adresem email juz istnieje', 'error');
            }
        }

        return response;
    }

    // public submit() {
    //     $body.on('click', '#sendRegistrationForm', this.prepare);
    // }

    public createRecaptcha() {
        let recaptcha = new ReCaptcha();

        let sitekey = $('#g-recaptcha').attr('data-sitekey');


        setTimeout(function () {
            $body.ready(() => {
                recaptcha.render(sitekey, 'g-recaptcha')
            })
        }, 500);
    }

    public onLoad() {
        $(this.Selector.FORM).on("load", this.validate);
    }

    public onChange() {
        $(this.Selector.FORM).on("change", this.validate);
    }
}

const register = new Register(Spinner);
register.createRecaptcha();
// register.submit();
register.onLoad();
register.onChange();
